import React from "react";
import { useDispatch } from "react-redux";
import { AuthActions } from "src/redux/Auth/actions";
import Button from "src/components/common/Button";
import styles from "./styles.module.scss";
import { ModalActions } from "src/redux/Modal/actions";
import SetupTOTP from "../SetupTOTP";

export default ({ mfaEnforced }) => {
    const dispatch = useDispatch();

    const handleSetupMfaClick = (e) => {
        e.preventDefault();
        dispatch(ModalActions.Close());
        dispatch(
            ModalActions.Open(SetupTOTP, {
                small: false,
                ignoreClickOutside: true,
                onClose: () => dispatch(AuthActions.Logout()),
            })
        );
    };

    const handleCancelMfaClick = async (e) => {
        e.preventDefault();
        dispatch(ModalActions.Close());
    };

    // "Remind me later" is hidden when MFA is enforced for this cpty
    const canSkip = !mfaEnforced;

    return (
        <div className={styles.mfa}>
            <h1>Security Notice</h1>

            <div className={styles.splitter} />

            <div className={styles.body}>
                <div className={styles.section}>
                    <div className={styles.paragraph}>
                        To help protect your account, TruWeb supports
                        multi-factor authentication (MFA).
                    </div>

                    <div className={styles.paragraph}>
                        If you choose to enable MFA, you will be asked to enter
                        a one-time passcode (OTP) when logging in. MFA can be
                        set up using a compatible authenticator app on your
                        smartphone, such as Google Authenticator or Authy.
                    </div>

                    <div className={styles.paragraph}>
                        If you need assistance with MFA setup, please contact
                        your IT Security team or Tru Support at{" "}
                        <a href="mailto:ops@kslnetwork.com">
                            ops@kslnetwork.com
                        </a>
                        .
                    </div>

                    <div className={`${styles.paragraph} ${styles.korean}`}>
                        계정 보안을 위해 TruWeb은 다단계 인증(MFA) 기능을
                        제공합니다.
                    </div>
                    <div className={styles.paragraph}>
                        MFA를 설정한 경우 로그인 시 일회용 암호(OTP)를 입력해야
                        합니다. MFA는 Google Authenticator 또는 Authy와 같은
                        스마트폰 인증 앱을 이용하여 설정할 수 있습니다.
                    </div>
                    <div className={styles.paragraph}>
                        MFA 설정과 관련하여 도움이 필요한 경우 귀사의 보안팀
                        또는 Tru 지원팀(
                        <a href="mailto:ops@kslnetwork.com">
                            ops@kslnetwork.com
                        </a>
                        )으로 문의하시기 바랍니다.
                    </div>
                </div>

                <div className={styles.buttons}>
                    <Button
                        value="Set up MFA now"
                        onClick={handleSetupMfaClick}
                        dataTestId="setup-mfa-button"
                    />

                    {canSkip && (
                        <Button
                            value="Remind me later"
                            transparent
                            onClick={handleCancelMfaClick}
                            dataTestId="cancel-mfa-button"
                        />
                    )}
                </div>
            </div>
        </div>
    );
};
